import styles from "./ModalTabSkeleton.module.scss";

type Props = {
  className?: string;
};

const ModalTabSkeleton = ({ className }: Props) => {
  return (
    <div className={`${styles.wrapper} ${className ?? ""}`}>
      <div className={`${styles.lineLg} skeleton`} />
      <div className={`${styles.lineMd} skeleton`} />
      <div className={`${styles.lineLg} skeleton`} />
      <div className={`${styles.lineSm} skeleton`} />
      <div className={`${styles.lineMd} skeleton`} />
      <div className={`${styles.lineXs} skeleton`} />
    </div>
  );
};

export default ModalTabSkeleton;
